/**
 * AISettingsPreview.js - Display AI-decided settings in Quick Mode
 */

import React from "react";
import { FiInfo } from "react-icons/fi";

const AISettingsPreview = ({ settings, script }) => {
  if (!settings) return null;

  const settingsItems = [
    { label: "Giọng đọc", value: settings.suggestedVoice, icon: "🎤" },
    { label: "Tốc độ", value: `${settings.suggestedSpeed}x`, icon: "⏱️" },
    { label: "Tỷ lệ", value: settings.suggestedAspectRatio, icon: "📐" },
    { label: "Hiệu ứng", value: settings.suggestedEffect, icon: "✨" },
    { label: "Phụ đề", value: settings.subtitleEnabled ? settings.subtitleEffect : "Tắt", icon: "💬" },
    { label: "Độ dài", value: settings.suggestedDuration, icon: "⏰" },
  ];

  return (
    <div className="ai-settings-preview">
      <div className="ai-settings-title">
        <span>🤖</span>
        <span>AI đã quyết định cài đặt tối ưu</span>
      </div>

      <div className="ai-settings-grid">
        {settingsItems.map((item, index) => (
          <div key={index} className="ai-setting-item">
            <div className="ai-setting-label">
              {item.icon} {item.label}
            </div>
            <div className="ai-setting-value">{item.value}</div>
          </div>
        ))}
      </div>

      {script && (
        <div style={{ marginTop: "1rem" }}>
          <div className="ai-setting-label" style={{ marginBottom: "0.5rem" }}>
            📝 Kịch bản AI
          </div>
          <div
            style={{
              background: "#f3f4f6",
              padding: "1rem",
              borderRadius: "0.5rem",
              color: "#374151",
              lineHeight: "1.6",
              fontSize: "0.9rem",
              border: "1px solid #e5e7eb",
            }}
          >
            {script}
          </div>
        </div>
      )}

      {settings.reasoning && (
        <div
          style={{
            marginTop: "1rem",
            padding: "0.75rem",
            background: "#eff6ff",
            borderRadius: "0.5rem",
            borderLeft: "3px solid #2563eb",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              color: "#2563eb",
              fontSize: "0.875rem",
              marginBottom: "0.5rem",
            }}
          >
            <FiInfo />
            <span>Lý do AI chọn cài đặt này</span>
          </div>
          <div style={{ color: "#6b7280", fontSize: "0.8rem", lineHeight: "1.5" }}>
            {settings.reasoning.voice && <div>• Giọng: {settings.reasoning.voice}</div>}
            {settings.reasoning.aspectRatio && <div>• Tỷ lệ: {settings.reasoning.aspectRatio}</div>}
            {settings.reasoning.effect && <div>• Hiệu ứng: {settings.reasoning.effect}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default AISettingsPreview;
